(function () {
  // ─── CONFIGURACIÓN ────────────────────────────────────────────────────────
  var CONFIG = {
    // Mensaje predeterminado que se abre en WhatsApp (puedes dejarlo vacío "")
    defaultMessage: "Hola, me gustaría obtener una cotización.",

    // Texto del globo persistente (se cierra con la X).
    // Acepta emojis. Pon "" para desactivarlo.
    popupText: "¿Quieres una cotización?\nEscríbenos 😊",

    // Color del botón (verde WhatsApp por defecto)
    buttonColor: "#25D366",

    // MODO PRUEBA: pon un número 0-23 para forzar esa hora y ver qué contacto aplica.
    // Pon null (o borra la línea) para usar el reloj real.
    testHour: null,

    // Horarios de atención: lista ordenada de reglas.
    // Se evalúan en orden; se usa el PRIMER contacto cuyo horario aplique.
    // Formato de hora: 0–23 (entero). "days" usa 0=Domingo … 6=Sábado.
    // Si no hay ninguna regla activa se usa "defaultContact".
    schedules: [
      {
        // 9:00 am – 6:59 pm → equipo de ventas (todos los días)
        name: "Horario ventas",
        phone: "5213319856883",
        message: "Hola, me gustaría obtener una cotización.",
        days: [0, 1, 2, 3, 4, 5, 6],
        startHour: 9,
        endHour: 19,
      },
    ],

    // Fuera de horario (7:00 pm – 8:59 am) → sofIA atiende automáticamente
    defaultContact: {
      phone: "5213321014889",
      message: "Hola, me gustaría obtener una cotización.",
    },
  };
  // ─── FIN DE CONFIGURACIÓN ─────────────────────────────────────────────────

  function getActiveContact() {
    // Siempre usa la hora de Ciudad de México, sin importar dónde esté el visitante
    var formatter = new Intl.DateTimeFormat("es-MX", {
      timeZone: "America/Mexico_City",
      hour: "numeric",
      weekday: "short",
      hour12: false,
    });
    var parts = formatter.formatToParts(new Date());
    var dayNames = { "dom": 0, "lun": 1, "mar": 2, "mié": 3, "jue": 4, "vie": 5, "sáb": 6 };
    var day = dayNames[parts.find(function(p){ return p.type === "weekday"; }).value.toLowerCase()] ?? new Date().getDay();
    var hour = CONFIG.testHour !== null && CONFIG.testHour !== undefined
      ? CONFIG.testHour
      : parseInt(parts.find(function(p){ return p.type === "hour"; }).value, 10);

    for (var i = 0; i < CONFIG.schedules.length; i++) {
      var s = CONFIG.schedules[i];
      var dayMatch = s.days.indexOf(day) !== -1;
      var hourMatch = hour >= s.startHour && hour < s.endHour;
      if (dayMatch && hourMatch) {
        return { phone: s.phone, message: s.message || CONFIG.defaultMessage };
      }
    }
    return {
      phone: CONFIG.defaultContact.phone,
      message: CONFIG.defaultContact.message || CONFIG.defaultMessage,
    };
  }

  function buildUrl(phone, message) {
    return (
      "https://wa.me/" + phone + "?text=" + encodeURIComponent(message)
    );
  }

  function injectStyles() {
    var style = document.createElement("style");
    style.textContent =
      ".wa-bubble{position:fixed;bottom:24px;right:24px;z-index:9999;display:flex;flex-direction:column;align-items:flex-end;gap:10px;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif}" +
      ".wa-popup{position:relative;background:#fff;color:#111;font-size:14px;line-height:1.45;padding:14px 36px 14px 16px;border-radius:12px;box-shadow:0 4px 20px rgba(0,0,0,.18);max-width:220px;white-space:pre-line;animation:wa-pop .25s ease}" +
      "@keyframes wa-pop{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}" +
      ".wa-popup-close{position:absolute;top:8px;right:8px;width:20px;height:20px;border:none;background:none;cursor:pointer;color:#888;font-size:16px;line-height:1;padding:0;display:flex;align-items:center;justify-content:center}" +
      ".wa-popup-close:hover{color:#333}" +
      ".wa-btn{width:56px;height:56px;border-radius:50%;background:" +
      CONFIG.buttonColor +
      ";display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px rgba(0,0,0,.25);cursor:pointer;transition:transform .15s,box-shadow .15s;text-decoration:none}" +
      ".wa-btn:hover{transform:scale(1.08);box-shadow:0 6px 18px rgba(0,0,0,.3)}" +
      ".wa-btn svg{width:30px;height:30px;fill:#fff}";
    document.head.appendChild(style);
  }

  function render() {
    injectStyles();

    var contact = getActiveContact();
    var url = buildUrl(contact.phone, contact.message);

    var wrapper = document.createElement("div");
    wrapper.className = "wa-bubble";

    // Globo persistente
    if (CONFIG.popupText) {
      var popup = document.createElement("div");
      popup.className = "wa-popup";
      popup.textContent = CONFIG.popupText;

      var closeBtn = document.createElement("button");
      closeBtn.className = "wa-popup-close";
      closeBtn.innerHTML = "&#x2715;";
      closeBtn.setAttribute("aria-label", "Cerrar");
      closeBtn.onclick = function () { popup.style.display = "none"; };

      popup.appendChild(closeBtn);
      wrapper.appendChild(popup);
    }

    var btn = document.createElement("a");
    btn.className = "wa-btn";
    btn.href = url;
    btn.target = "_blank";
    btn.rel = "noopener noreferrer";
    btn.setAttribute("aria-label", "Abrir WhatsApp");
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15' +
      "-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475" +
      "-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52" +
      ".149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207" +
      "-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372" +
      "-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2" +
      " 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719" +
      ' 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>' +
      '<path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.126 1.532 5.862L.057 23.428' +
      "a.75.75 0 0 0 .915.915l5.684-1.485A11.945 11.945 0 0 0 12 24c6.627 0 12-5.373" +
      ' 12-12S18.627 0 12 0zm0 22c-1.891 0-3.667-.51-5.197-1.4l-.37-.217-3.828 1.001' +
      " 1.012-3.737-.232-.376A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10" +
      ' 10-4.477 10-10 10z"/>' +
      "</svg>";

    wrapper.appendChild(btn);
    document.body.appendChild(wrapper);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", render);
  } else {
    render();
  }
})();
